"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Svg = _interopRequireDefault(require("../../../../Svg/Svg"));
var _currency = require("../../../../../currency");
var _Pill = _interopRequireDefault(require("../../../../Pill/Pill"));
var _constants = require("../../../../constants");
var _Waves = _interopRequireDefault(require("../../../../Svg/TYWSymbols/Waves"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var DestinationWide = function DestinationWide(_ref) {
  var size = _ref.size,
    textMain = _ref.textMain,
    price = _ref.price,
    currency = _ref.currency,
    whiteFont = _ref.whiteFont,
    textTop = _ref.textTop,
    expandable = _ref.expandable,
    on = _ref.on,
    soldOut = _ref.soldOut,
    dates = _ref.dates,
    description = _ref.description,
    pills = _ref.pills;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hover-link-show"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hover-link absolute height-100% width-100% flex flex-column justify-center items-center text-center backdrop"
  }, /*#__PURE__*/_react["default"].createElement(_Waves["default"], {
    className: "icon--xl margin-bottom-xxs",
    fill: "var(--color-brand-highlight-2)"
  }), /*#__PURE__*/_react["default"].createElement("h2", {
    className: "d8-u-color-white text-lg text-xl@md"
  }, "Explore", /*#__PURE__*/_react["default"].createElement("br", null), "Destination")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "width-100% d8-u-relative flex flex-column justify-between image--destination height-100% ".concat(size)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "image--destination__top-bar width-100% padding-sm padding-x-md@md flex justify-between d8-u-color-white font-medium text-uppercase"
  }, dates && /*#__PURE__*/_react["default"].createElement("p", {
    style: {
      borderRight: '1px solid #ffffff7a',
      marginRight: 15
    },
    className: (0, _classnames["default"])('width-50%', 'destination--price', 'text-xs', 'd8-u-ls-sm', whiteFont && 'd8-u-color-white')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "block margin-bottom-xs"
  }, "Dates"), dates), price && /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _classnames["default"])('width-50%', 'destination--price', 'text-xs', 'd8-u-ls-sm', whiteFont && 'd8-u-color-white')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "block margin-bottom-xs"
  }, "Price"), "from", ' ', /*#__PURE__*/_react["default"].createElement(_currency.FormatCurrency, {
    amount: typeof price !== 'number' ? parseFloat(price.replace(/[^\d.]/g, '')) : price,
    baseCurrency: currency
  }), "pp")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "image--destination__bottom-bar padding-md padding-x-sm padding-x-md@md"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "width-100%"
  }, pills && pills.map(function (pill, index) {
    return /*#__PURE__*/_react["default"].createElement(_Pill["default"], {
      key: index,
      className: "margin-right-sm margin-bottom-sm",
      icon: pill.icon,
      title: pill.title,
      type: pill.type
    });
  }), textMain === 'Croatia, Original' && /*#__PURE__*/_react["default"].createElement(_Pill["default"], {
    className: "margin-right-sm margin-bottom-sm",
    title: "Most popular",
    type: _constants.PILL_TYPES.PRIMARY
  }), soldOut && /*#__PURE__*/_react["default"].createElement(_Pill["default"], {
    className: "margin-right-sm margin-bottom-sm",
    icon: "ban",
    title: "Sold out",
    type: _constants.PILL_TYPES.SOLD_OUT
  })), textMain && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("h3", {
    className: (0, _classnames["default"])('card--image__heading', 'margin-bottom-xs', 'd8-u-ls-sm', 'text-md', 'text-lg@md', whiteFont && 'd8-u-color-white')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "d8-u-text-uppercase d8-u-ls-sm d8-u-text-bold text-lg text-xl@md"
  }, textMain.split(',')[0]), /*#__PURE__*/_react["default"].createElement("br", null), textMain.split(',')[1]), description && /*#__PURE__*/_react["default"].createElement("p", {
    className: "d8-u-color-white"
  }, description)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mobile-only btn btn--primary margin-top-md"
  }, "Explore destination")))));
};
DestinationWide.propTypes = {
  size: _propTypes["default"].string,
  textMain: _propTypes["default"].string,
  price: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  textTop: _propTypes["default"].string,
  whiteFont: _propTypes["default"].bool,
  expandable: _propTypes["default"].bool,
  dates: _propTypes["default"].string,
  on: _propTypes["default"].bool,
  soldOut: _propTypes["default"].bool,
  currency: _propTypes["default"].string,
  description: _propTypes["default"].string,
  pills: _propTypes["default"].array
};
DestinationWide.defaultProps = {
  currency: 'EUR'
};
var _default = exports["default"] = DestinationWide;